


import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import { Action, Getter } from 'vuex-class'
import { IRecipient } from '@/entities/notices'
import { Suggestion, SuggestionNew } from '@/entities/suggestions'

@Component<SuggestionCreateBase>({
    components: {}
})
export default class SuggestionCreateBase extends Vue {
    @Getter public suggestionMentionUsers!: IRecipient[]

    @Action public loadSuggestionMentionUsers
    @Action public createSuggestion!: (
        suggestion: SuggestionNew
    ) => Promise<Suggestion>

    public title = ''
    public body = ''

    protected mentions: IRecipient[] = []

    public async submitSuggestionBase(event: Event) {
        event.preventDefault()
        const { title, body, mentions } = this
        if (this.submittable) {
            return await this.createSuggestion({ title, body, mentions })
        }
    }

    public get submittable() {
        return this.title && this.body
    }

    public onMention(mentions: IRecipient[]) {
        this.mentions = mentions
    }

    public onInputChange(text: string) {
        this.body = text
    }
}
